import { PageLifecycleStates, pageLifeCycleWatcher, } from '@tunein/web-utils';
import { isBrowser } from 'es-toolkit';
import EventEmitter from 'eventemitter3';
export class ScreenViewManager extends EventEmitter {
    #isVisible = false;
    #screen = null;
    constructor() {
        super();
        if (!isBrowser()) {
            return;
        }
        pageLifeCycleWatcher.init();
        const initialState = pageLifeCycleWatcher.state;
        this.#isVisible =
            initialState === PageLifecycleStates.ACTIVE ||
                initialState === PageLifecycleStates.PASSIVE;
        pageLifeCycleWatcher.on('change', this.#handleLifecycleChange);
    }
    setScreen({ name, guideId, isDisplayAdEligible }) {
        const isInitialScreen = !this.#screen;
        const lastScreen = this.#screen;
        this.#screen = {
            name,
            guideId: guideId || '',
            isDisplayAdEligible: (isDisplayAdEligible || false).toString(),
        };
        if (isInitialScreen && !this.#isVisible) {
            return;
        }
        if (lastScreen) {
            this.emit('change', { isVisible: false, ...lastScreen });
        }
        this.emit('change', { isVisible: true, ...this.#screen });
    }
    clearScreen() {
        if (!this.#screen)
            return;
        this.emit('change', { isVisible: false, ...this.#screen });
        this.#screen = null;
    }
    #handleLifecycleChange = (newState) => {
        const isVisible = newState === PageLifecycleStates.ACTIVE ||
            newState === PageLifecycleStates.PASSIVE;
        if (!this.#screen || isVisible === this.#isVisible)
            return;
        this.#isVisible = isVisible;
        this.emit('change', { isVisible, ...this.#screen });
    };
}
